import layout_controller from './layout_controller'
import { canCachePage } from '../history/navigation_policy'
import projects_overlays from '../projects_overlays/projects_overlays'
import { utility_controller } from '../utility/utility_controller'

// Cache for preloaded layout data
var preloadCache = {}
// Track loading states to prevent duplicate requests
var preloadLoading = {}
var lastKnownQTranslateLang = ''

/**
 * For qTranslate-XT, the same `id + type` resolves to different markup per
 * language (the cached server response is already translated for the lang
 * of the request URL). If we keyed only by id+type, hovering `/en/page-B`
 * and then clicking `/de/page-B` would return the EN preload for the DE
 * URL — which is exactly the "stuck on one language" bug.
 *
 * Detection strategy: if qTranslate-XT exposes its enabled languages via
 * `layData.qtranslate_languages`, look at the `lang=` query param (query
 * mode) and all URL path segments (path-prefix mode). Scanning all path
 * segments matters for WordPress installs in a subdirectory such as
 * `/site/es/page/`, where the language is not the first segment. Anything
 * else returns '' (default language). Polylang/WPML are handled by
 * disabling the server cache entirely (see Lay_Layout_Cache::is_cache_enabled),
 * so we don't need to handle them here.
 */
var getUrlLang = function (urlString) {
	if (!urlString) return ''
	var langs = layData.qtranslate_languages
	if (!jQuery.isArray(langs) || langs.length === 0) return ''
	try {
		var u = new URL(urlString, window.location.origin)
		var qlang = u.searchParams.get('lang')
		if (qlang && langs.indexOf(qlang) !== -1) return qlang
		var segments = u.pathname.split('/').filter(Boolean)
		for (var i = 0; i < segments.length; i++) {
			if (langs.indexOf(segments[i]) !== -1) return segments[i]
		}
	} catch (e) {
		// Bad URL — fall through to ''.
	}
	return ''
}

var isValidQTranslateLang = function (lang) {
	var langs = layData.qtranslate_languages
	return lang && jQuery.isArray(langs) && langs.indexOf(lang) !== -1
}

var getDefaultQTranslateLang = function () {
	if (!layData.is_qtranslate_active) return ''
	if (isValidQTranslateLang(layData.qtranslate_default_language)) return layData.qtranslate_default_language
	if (isValidQTranslateLang(layData.qtranslate_current_language)) return layData.qtranslate_current_language
	if (jQuery.isArray(layData.qtranslate_languages) && layData.qtranslate_languages.length > 0) return layData.qtranslate_languages[0]
	return ''
}

var setLastKnownQTranslateLang = function (lang) {
	if (isValidQTranslateLang(lang)) {
		lastKnownQTranslateLang = lang
	}
	return lastKnownQTranslateLang
}

var getHistoryQTranslateLang = function () {
	try {
		var state = window.history && window.history.state ? window.history.state : null
		if (state && isValidQTranslateLang(state.qtranslate_lang)) {
			return state.qtranslate_lang
		}
		if (state && state.usr && isValidQTranslateLang(state.usr.qtranslate_lang)) {
			return state.usr.qtranslate_lang
		}
	} catch (e) {}
	return ''
}

var rememberQTranslateLang = function (urlString) {
	var lang = getUrlLang(urlString || window.location.href)
	if (lang === '') lang = getDefaultQTranslateLang()
	setLastKnownQTranslateLang(lang)
	return lang
}

var rememberQTranslateLangFromHistoryState = function () {
	var lang = getHistoryQTranslateLang()
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	return rememberQTranslateLang(window.location.href)
}

var getQTranslateLangForNavigation = function (urlString) {
	var lang = getUrlLang(urlString || '')
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	return rememberQTranslateLang(window.location.href)
}

var getUrlLangForRequest = function (urlString) {
	var lang = getUrlLang(urlString || window.location.href)
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	lang = getHistoryQTranslateLang()
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	// Project Overlay URLs can be language-neutral when qTranslate-XT hides
	// the default language. During AJAX navigation, pushState may already have
	// replaced `/site/ca/services/` with `/site/test-project/`, so we keep the
	// last language seen before the URL swap as a fallback.
	lang = getUrlLang(window.location.href)
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	if (lastKnownQTranslateLang !== '') {
		return lastKnownQTranslateLang
	}
	lang = getUrlLang(document.referrer)
	if (lang !== '') {
		setLastKnownQTranslateLang(lang)
		return lang
	}
	return getDefaultQTranslateLang()
}

/**
 * Project overlay markup and full-page project markup differ (see
 * Lay_Layout::getLayout project_overlay option). Server transients and
 * masterCache were split by context in layout_cache; preloadCache must
 * match or a hover-preload poisons the wrong navigation path.
 */
var resolveIsProjectOverlay = function (type, mode) {
	if (type != 'project') {
		return 'false'
	}
	if (!utility_controller.isProjectsOverlayEnabled()) {
		return 'false'
	}
	if (projects_overlays.isOverlayDisplayBlock()) {
		return 'true'
	}
	if (mode === 'hover') {
		// Hover cannot call shouldOpenOverlay() — it is still false until click.
		// Mirror push-state rules: page→project opens overlay; project→project does not.
		var currentType = jQuery('body').attr('data-type')
		return currentType === 'project' ? 'false' : 'true'
	}
	return projects_overlays.shouldOpenOverlay() ? 'true' : 'false'
}

var projectOverlayCacheSuffix = function (isProjectOverlay) {
	return isProjectOverlay == 'true' ? '_overlay' : '_page'
}

/**
 * Build the preloadCache key. When a language is detected from the URL,
 * append it so each language gets its own slot.
 */
var buildCacheKey = function (id, type, urlString, isProjectOverlay) {
	var key = id + '_' + type
	if (type == 'project' && utility_controller.isProjectsOverlayEnabled()) {
		key += projectOverlayCacheSuffix(isProjectOverlay != null ? isProjectOverlay : resolveIsProjectOverlay(type, 'navigate'))
	}
	var lang = getUrlLangForRequest(urlString || window.location.href)
	if (lang !== '') key += '_' + lang
	return key
}

/**
 * Check if a page contains shortcodes
 * Similar to shortcodes_controller.pageContainsShortcode but works with id and type directly
 */
var pageContainsShortcode = function (id, type) {
	// Convert type to match shortcode info format (project/page -> post)
	var typeToCheck = type
	if (type == 'project' || type == 'page') {
		typeToCheck = 'post'
	}

	// Check if shortcodes array exists and contains this page
	var shortcodes = layData.shortcodes
	if (jQuery.isArray(shortcodes)) {
		for (var i = 0; i < shortcodes.length; i++) {
			if (shortcodes[i]['info']['type'] == typeToCheck && shortcodes[i]['info']['id'] == id) {
				return true
			}
		}
	}

	return false
}

var preloadLayout = function (id, type, url) {
	if (!canCachePage({ id, type }, url)) return
	// `url` is the URL of the link being preloaded. Without it we'd key
	// every language's response under the same id_type slot and serve the
	// wrong language after a switch — see getUrlLang() above.
	var is_project_overlay = resolveIsProjectOverlay(type, 'hover')
	var cacheKey = buildCacheKey(id, type, url, is_project_overlay)

	if (layData.activate_lay_cache !== '1') {
		return
	}

	if (pageContainsShortcode(id, type)) {
		return
	}

	if (preloadCache[cacheKey]) {
		return
	}
	if (preloadLoading[cacheKey]) {
		return
	}

	// Check master cache first. Master cache is keyed by cache context on the
	// server side; for qTranslate-XT we can't reuse it across languages
	// because the cached entries are translated to whatever language was
	// active when the master cache was built. Skip this shortcut whenever
	// qTranslate-XT is active to avoid serving the wrong language.
	var masterCacheKey = is_project_overlay == 'true' ? 'project_overlay_' + id : id
	if (
		!layData.is_qtranslate_active &&
		layout_controller &&
		layout_controller.getStateMap &&
		layout_controller.getStateMap().masterCache &&
		layout_controller.getStateMap().masterCache[masterCacheKey]
	) {
		preloadCache[cacheKey] = { layout: layout_controller.getStateMap().masterCache[masterCacheKey] }
		return
	}

	// Mark as loading
	preloadLoading[cacheKey] = true

	var ajax_data = {
		action: 'get_laytheme_layout',
		is_project_overlay: is_project_overlay,
		id: id,
		type: type,
		password: '',
		is_cache_build: 'true', // Mark as cache build to get raw multilingual content
	}
	var ajaxLang = getUrlLangForRequest(url || window.location.href)
	if (ajaxLang !== '') {
		// qTranslate-XT reads `lang` during request language detection.
		ajax_data.lang = ajaxLang
	}

	// Use a separate progress object for preloading to avoid conflicts
	jQuery.ajax({
		url: layData.ajax_url,
		data: ajax_data,
		type: 'post',
		success: (json) => {
			try {
				var result = window.JSON.parse(json)
				// Only cache successful responses that don't require password
				if (!result.requiresFullPageLoad && result.layout && result.layout.password !== 'protected') {
					preloadCache[cacheKey] = result
				}
			} catch (e) {}
			// Clear loading state
			delete preloadLoading[cacheKey]
		},
		error: (event) => {
			// Remove from cache on error
			delete preloadCache[cacheKey]
			// Clear loading state
			delete preloadLoading[cacheKey]
		},
	})
}

var getCachedData = function (id, type, isProjectOverlay) {
	// Read at navigation time. `window.location.href` reflects the URL
	// pushState just navigated to, so for a language switch this picks up
	// the new language and we miss the previous-language preload.
	var overlay =
		isProjectOverlay != null ? isProjectOverlay : resolveIsProjectOverlay(type, 'navigate')
	var cacheKey = buildCacheKey(id, type, window.location.href, overlay)
	var hit = preloadCache[cacheKey]
	return hit
}

/**
 * Stash a layout result that came back via regular AJAX navigation, so the
 * same page is instantly available on re-visit during this session without
 * waiting for a hard reload to refresh the master cache. Mirrors the data
 * shape preloadLayout writes (`{ layout: {...} }` parsed response).
 */
var cacheResult = function (id, type, result, isProjectOverlay) {
	if (!canCachePage({ id, type })) return
	if (layData.activate_lay_cache !== '1') return
	if (!result || !result.hasOwnProperty('layout')) return
	if (result.layout && result.layout.password === 'protected') return
	if (pageContainsShortcode(id, type)) return
	// `window.location.href` is the URL the navigation just landed on, so
	// the result we got back is in that URL's language.
	var overlay =
		isProjectOverlay != null ? isProjectOverlay : resolveIsProjectOverlay(type, 'navigate')
	var cacheKey = buildCacheKey(id, type, window.location.href, overlay)
	preloadCache[cacheKey] = result
	delete preloadLoading[cacheKey]
}

var clearPreloadCache = function () {
	preloadCache = {}
	preloadLoading = {}
}

var getPreloadCacheStats = function () {
	return {
		cached: Object.keys(preloadCache).length,
		loading: Object.keys(preloadLoading).length,
		cachedKeys: Object.keys(preloadCache),
		loadingKeys: Object.keys(preloadLoading),
	}
}

var bindPreloadHoverEvents = function () {
	// Disable preloading if caching is not active
	if (layData.activate_lay_cache !== '1') {
		return
	}

	// Bind mouseenter events to anchors with data-id and data-type attributes
	jQuery(document).on('mouseenter', 'a[data-id][data-type]', function () {
		var $anchor = jQuery(this)
		var id = $anchor.attr('data-id')
		var type = $anchor.attr('data-type')
		var href = $anchor.attr('href') || ''

		// Don't preload if it's the current page
		if (id === jQuery('body').attr('data-id') && type === jQuery('body').attr('data-type')) {
			return
		}

		// Pass the anchor's href so the cache key can be language-aware (qTranslate-XT)
		preloadLayout(id, type, href)
	})
}

var preload_controller = {
	preloadLayout: preloadLayout,
	getCachedData: getCachedData,
	cacheResult: cacheResult,
	clearPreloadCache: clearPreloadCache,
	getPreloadCacheStats: getPreloadCacheStats,
	bindPreloadHoverEvents: bindPreloadHoverEvents,
	getUrlLang: getUrlLang,
	rememberQTranslateLang: rememberQTranslateLang,
	rememberQTranslateLangFromHistoryState: rememberQTranslateLangFromHistoryState,
	getQTranslateLangForNavigation: getQTranslateLangForNavigation,
	getUrlLangForRequest: getUrlLangForRequest,
	buildCacheKey: buildCacheKey,
}

if (typeof window !== 'undefined') {
	rememberQTranslateLang(window.location.href)
	// Expose for ad-hoc inspection in DevTools — `layCachePreload.getStats()`.
	window.layCachePreload = preload_controller
}

export default preload_controller
